import { Outlet } from 'react-router-dom'
import Navbar from './Navbar'

function PublicLayout() {
  return (
    <div className='LoggedInContainer' style={{ paddingTop: '65px' }}>
      <Navbar />
      <div className='publicMainContent'>
        <Outlet />
      </div>
    </div>
  )
}

export default PublicLayout
